<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <span>Verificação de consistência</span>
                        <h1>Dê À sua escrita Um toque profissional</h1>
                        <p>Economize tempo e dê à sua escrita um acabamento profissional em apenas alguns cliques. A Verificação
                            de Consistência do Trinka corrige inconsistências difíceis de encontrar, especialmente em um
                            documento longo.</p>
                        <a href="https://cloud.trinka.ai/signup?_rg=PT" id="autoEditGetStart" target="_blank">Iniciar</a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/Consistency-Checks.png" alt="consistency checks">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="SectionHowItWrok">
        <div class="container">
            <div class="row">
                <div class="col-xl-6">
                    <div class="ImgSectionHowItWrok">
                        <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                            <img src=".././../../assets/images/ConsistencyCheckThumbnail.png" alt="consistency check" class="img-fluid eposter-img">
                        </a>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="contentSectionHowItWrok">
                        <h2>Veja isto em ação</h2>
                        <div class="HeadingSubLine"></div>
                        <p style="margin-bottom: 10px;">Confira o passo a passo fácil do vídeo para começar a usar a Verificação de Consistência rapidamente.</p>
                        <p style="margin-bottom: 10px;">É um tutorial passo a passo detalhado para ajudá-lo a usar Trinka ao máximo. Tem mais perguntas?
                            Navegue pelas nossas perguntas frequentes
                            <a style="color: #0000ff;" (click)="scroll(target)" class="link">aqui</a>.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="cloud_key_features">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>Principais recursos da verificação de consistência do Trinka</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Trinka identifica as várias inconsistências para tornar a sua escrita profissional.
                            <br /> Os seguintes tipos de inconsistências são identificados e corrigidos:
                        </p>
                    </div>
                </div>
            </div>
            <div class="row">

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards  ">
                        <div class="feature_num">01</div>
                        <h3>Ortografias</h3>
                        <p class="fearureCardText">Trinka identifica as diferentes ortografias
                            <span>(Americana Vs. Britânica)</span> usadas para a mesma palavra.</p>
                        <div class="custom_radioButtons">
                            <p>
                                <input type="radio" id="colourSection" name="spellingchecks" checked>
                                <label for="colourSection">colour (4 occurences) </label>
                            </p>
                            <p>
                                <input type="radio" id="colorSections" name="spellingchecks">
                                <label for="colorSections">color (4 occurences) </label>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards ">
                        <div class="feature_num">02</div>
                        <h3>Hífens e travessões</h3>
                        <p class="fearureCardText">Trinka encontra o uso inconsistente de <span>hífens e travessões</span> e os torna consistentes com um clique.
                        </p>
                        <div class="custom_radioButtons">
                            <p>
                                <input type="radio" id="ultra-violet" name="dashesCehcks" checked>
                                <label for="ultra-violet">ultra-violet (5 occurrences)
                                </label>
                            </p>
                            <p>
                                <input type="radio" id="ultra_violet" name="dashesCehcks">
                                <label for="ultra_violet">ultra violet (5 occurrences)
                                </label>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards ">
                        <div class="feature_num">03</div>
                        <h3>Estilo de número</h3>
                        <p class="fearureCardText">O uso intercambiável de <span>numerais e números soletrados</span> é uma das inconsistências mais comuns. Trinka
                            ajuda você a evitá-lo com um clique.</p>
                        <!-- <p class="fearureCardText">Interchangeably using
                                <span>numerals and spelled out numbers</span> is one of the most common inconsistencies. Trinka helps
                                you avoid it with a click.</p> -->
                        <div class="custom_radioButtons">
                            <div class="custom_radioButtons">
                                <p>
                                    <input type="radio" id="averagesixyears" name="sadfdashesCehcks" checked>
                                    <label for="averagesixyears">
                                        <b>average six years</b>
                                        <img src="../../../assets/images/spacingArrow.png" />
                                        <b>average 6 years</b>
                                    </label>
                                </p>
                                <p>
                                    <input type="radio" id="averagesixyears" name="sadfdashesCehcks">
                                    <label for="averagesixyears">
                                        <b>average 6 years</b>
                                        <img src="../../../assets/images/spacingArrow.png" />
                                        <b>average six years</b>
                                    </label>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="feature_num">04</div>
                        <h3>Símbolos</h3>
                        <p class="fearureCardText">Trinka entende quando você usa símbolos de forma intercambiável ou os soletra.</p>
                        <div class="custom_radioButtons">
                            <p>
                                <input type="radio" id="exampeFourContent_one" name="exampeFourContent" checked>
                                <label for="exampeFourContent_one">
                                    <b>TNF-alpha"</b>
                                    <img src="../../../assets/images/spacingArrow.png" />
                                    <b>tnf-α"</b>
                                </label>
                            </p>
                            <p>
                                <input type="radio" id="exampeFourContent_two" name="exampeFourContent">
                                <label for="exampeFourContent_two">
                                    <b>tnf-α"</b>
                                    <img src="../../../assets/images/spacingArrow.png" />
                                    <b>TNF-alpha"</b>
                                </label>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="feature_num">05</div>
                        <h3>Espaçamento</h3>
                        <p class="fearureCardText">Os espaços são difíceis de serem detectados e, portanto, são facilmente perdidos. Trinka ajuda você
                            a eliminar o <span>espaçamento inconsistente</span> ao longo de sua escrita com apenas alguns cliques. </p>
                        <div class="custom_radioButtons">
                            <p>
                                <input type="radio" id="exampeFiveContent_one" name="exampeFiveContent" checked>
                                <label for="exampeFiveContent_one">
                                    <b>p
                                        <0</b>
                                            <img src="../../../assets/images/spacingArrow.png" />
                                            <b>p
                                                < 0</b>
                                </label>
                            </p>
                            <p>
                                <input type="radio" id="exampeFiveContent_two" name="exampeFiveContent">
                                <label for="exampeFiveContent_two">
                                    <b>p
                                        < 0</b>
                                            <img src="../../../assets/images/spacingArrow.png" />
                                            <b>p
                                                <0</b>
                                </label>
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <!-- <div class="cloud_key_features toolbox_img_content">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>View a Sample Report</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
            </div>
            <div class="row">

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="consistency_right_text">
                            <h2>Dashes</h2>
                            <div class="custom_radioButtons">
                                <p>
                                    <input type="radio" id="ultra-violet" name="dashesCehcks" checked>
                                    <label for="ultra-violet">ultra-violet (5 occurrences)
                                    </label>
                                </p>
                                <p>
                                    <input type="radio" id="ultra_violet" name="dashesCehcks">
                                    <label for="ultra_violet">ultra violet (5 occurrences)
                                    </label>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="consistency_right_text">
                            <h2>Spacing</h2>
                            <div class="custom_radioButtons">
                                <p style="margin: 0;">
                                    <input type="radio" id="addSpaicng" name="spacingChecks" checked>
                                    <label for="addSpaicng">Add space</label>
                                </p>
                                <ul style="margin-bottom: 20px;">
                                    <li>p
                                        <0 <img src="../../../assets/images/spacingArrow.png" /> p
                                        < 0 </li>
                                            <li>p=0
                                                <img src="../../../assets/images/spacingArrow.png" />p = 0 </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="consistency_right_text">
                            <h2>Numbers</h2>
                            <div class="custom_radioButtons">
                                <p style="margin: 0;">
                                    <input type="radio" id="spelledOut" name="numberschecks" checked>
                                    <label for="spelledOut">Spelled-out
                                        <img src="../../../assets/images/spacingArrow.png" /> Numeral
                                    </label>
                                </p>
                                <ul style="margin-bottom: 20px;">
                                    <li>average six years
                                        <img src="../../../assets/images/spacingArrow.png" />average 6 years </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="consistency_right_text">
                            <h2>Spelling</h2>
                            <div class="custom_radioButtons">
                                <p>
                                    <input type="radio" id="colourSection" name="spellingchecks" checked>
                                    <label for="colourSection">colour (4 occurences) </label>
                                </p>
                                <p>
                                    <input type="radio" id="colorSections" name="spellingchecks">
                                    <label for="colorSections">color (4 occurences) </label>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="consistency_right_text">
                            <h2>Greek Letter Style</h2>
                            <div class="custom_radioButtons">
                                <p style="margin: 0;">
                                    <input type="radio" id="GreekSpelledOut" name="Greekletterstyle" checked>
                                    <label for="GreekSpelledOut">Spelled-out
                                        <img src="../../../assets/images/spacingArrow.png" /> Symbol
                                    </label>
                                </p>
                                <ul style="margin-bottom: 20px;">
                                    <li>TNF-alpha"
                                        <img src="../../../assets/images/spacingArrow.png" />tnf-α"
                                    </li>
                                    <li>"Beta particles
                                        <img src="../../../assets/images/spacingArrow.png" />"β particles
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div> -->
    <div class="use_trinka_other_app accomplishBrilliantWrap">
        <div class="container">
            <div class="accomplishBrilliantSection">
                <h2>Garanta que A sua escrita seja consistente e profissional</h2>
                <a href="https://cloud.trinka.ai/signup?_rg=PT" target="_blank">Iniciar</a>
            </div>
        </div>
    </div>
    <!-- <div class="forpersonlized_sections">
        <p>Experience Advanced Writing Assistance</p>
        <div class="forpersonlizedFooter">
            <a href="https://cloud.trinka.ai/signup?_rg=PT" target="_blank">Get Started</a>
        </div>
    </div> -->
    <div class="pricingQuestionAnwser" #target>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="pricingHeadingQuestion">
                        <h2>Perguntas feitas frequentemente</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
                <div class="col-lg-10">
                    <div class="pricingQuestionsList">
                        <div class="accordion" id="faq">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        Como funciona a Verificação de Consistência do Trinka?</a>
                                </div>

                                <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>A Verificação de Consistência do Trinka encontra automaticamente variações em várias
                                            inconsistências comuns feitas por escritores e lista todas elas para você. Ela
                                            também oferece opções de correção. Tudo que você precisa fazer é escolher o estilo
                                            certo e confirmar. Trinka faz o resto.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">Onde posso encontrar o recurso de Verificação de Consistência?</a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>O recurso de Verificação de Consistência está atualmente disponível no editor de
                                            Nuvem para todos os usuários.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        O recurso de Verificação de Consistência requer créditos?
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Atualmente, nenhum crédito é necessário para usar o recurso Verificação de consistência.
                                            Você pode usar o recurso quantas vezes quiser.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        Quando eu deveria usar o recurso de Verificação de Consistência?
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Idealmente, você deve executar o recurso de Verificação de Consistência depois de
                                            terminar de escrever. No entanto, você pode executá-lo quantas vezes quiser e
                                            sempre que achar necessário.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="card">
                                <div class="card-header" id="QuestionFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        Corrija inconsistências em sua escrita com a Verificação de Consistência do Trinka
                                    </a>
                                </div>

                                <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Economize tempo e dê à sua escrita um acabamento profissional com apenas alguns cliques
                                            com a Verificação de Consistência do Trinka
                                        </p>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>
    <div class="use_trinka_other_app">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="use_trinka_content">
                        <div class="use_trinka_heading">
                            <div class="howItWorkHeading lineWhiteColor">
                                <h2>Use o Trinka em outros aplicativos</h2>
                                <div class="HeadingSubLine"></div>
                            </div>
                        </div>
                        <div class="others_app_name">
                            <ul>
                                <li>
                                    <a href="https://www.trinka.ai/pt/trinkacloud">
                                        <div class="app_name_content" routerLink="/trinkacloud">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="trinka cloud">
                                            <h3>Trinka Cloud</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/pt/wordplugin">
                                        <div class="app_name_content" routerLink="">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Others_App_MSWord.svg" alt="ms word">
                                            <h3>MS Word Plug-in</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/pt/browser-plugin">
                                        <div class="app_name_content" routerLink="/browser-plugin">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/other_Apps_browser.svg" alt="bowser plugin">
                                            <h3>Plugins do navegador</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/pt/enterprise">
                                        <div class="app_name_content" style="padding: 0px;" routerLink="/enterprise">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_Apps_enterprise.svg" alt="enterprise">
                                            <h3 style="margin: 0 0 -2px 0;">Empresas</h3>
                                            <span style="font-size: 12px; color: #000; position: relative;">(API, JS & On-Premise)
                                            </span>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/hTaMLLHICCo"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>